import { Component } from '@angular/core';

import { Router, NavigationEnd } from '@angular/router';

import { MechanicsService } from "./services/mechanics.service"
import { UserService } from "./services/user.service"

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.styl'],
    standalone: false
})
export class AppComponent {

	constructor(public router: Router,
		public ms: MechanicsService,
		public us: UserService) {

		const l = `app.component constructor - `

		router.events
			.subscribe(val => {
				if (val instanceof NavigationEnd) {
					// console.log(`router event subscribe - currentUrl = `, val["url"])
					this.ms.currentUrl = val["url"]
					sessionStorage.setItem("pii_currentPath", val["url"])
				}
			});

		this.checkFrontAndBackVersions()
		this.us.loadSettings()
	}

	ngAfterViewChecked() {

		const dialog = document.getElementById('modalsHomepage') as HTMLDialogElement;
		if (this.ms.modal() && dialog && !dialog.open && dialog.firstElementChild) {
			dialog.showModal();
		}

	}

	async checkFrontAndBackVersions() {
		const l = `checkFrontAndBackVersions() - `

		try {
			const frontendVersion = document.querySelector("meta[name='frontendVersion']").getAttribute("version");

			const backendVersion = (await this.us.call(`/api/getBackendVersion`)).backendVersion;

			if ([frontendVersion, backendVersion].includes(null)) {
				throw `Front-end (${frontendVersion}) and/or backEnd (${backendVersion}) versions were read as null!`
			}

			if (frontendVersion === backendVersion) {
				console.info(`%c${l}Front-end and back-end versions do match: ${frontendVersion}`, "background: darkgreen; color:white")
			} else {
				console.error(`%c${l}Front-end (${frontendVersion}) and back-end (${backendVersion}) versions do not match! Was the back-end restarted?`, "background:crimson; color:white;")
			}
		} catch (err) {
			console.error(`${l}caught error: `, err)
		}

	}
}
